/*
  Gratis-cadeau-actie (willekeurige zak Haribo bij bestelwaarde vanaf de
  drempel, met kortingscode).

  Legt het cadeau automatisch in de winkelwagen zodra aan BEIDE voorwaarden is
  voldaan: het subtotaal — EXCLUSIEF het cadeau zelf — haalt de drempel, én de
  actiecode staat in de winkelwagensessie (de QR op de flyer zet hem via
  /discount/<code>). Zodra de klant eronder zakt, de code weghaalt of de actie
  afloopt, gaat het cadeau er weer uit. De regel krijgt de line-item-property
  `_cadeau: haribo`; daarmee is de cadeauregel te onderscheiden van dezelfde
  zak die de klant zelf koopt (properties beginnend met `_` zijn verborgen voor
  de klant). De prijs wordt op nul gezet door de Shopify-kortingscode, niet door
  dit script — dit script regelt alleen de aanwezigheid in de mand.

  Het cadeau is een WILLEKEURIGE zak uit `cfg.varianten` (de cadeaucollectie).
  Is de geloote zak net uitverkocht, dan wordt de volgende uit de geschudde
  lijst geprobeerd — de zakken staan op `inventory_policy: deny`, dus een
  uitverkochte variant weigert de /cart/add gewoon.

  Configuratie komt uit `window.HARIBO_ACTIE` (snippets/haribo-actie.liquid).
  Het script laadt ALTIJD, ook als de actie uit staat: een cadeau dat nog in een
  oude winkelwagen ligt moet er dan juist uit.
*/
(function () {
  var cfg = window.HARIBO_ACTIE;
  if (!cfg || !cfg.varianten || !cfg.varianten.length) return;

  var origFetch = window.fetch.bind(window);
  var bezig = false;
  var varianten = cfg.varianten.map(String);

  function pad(naam, fallback) {
    return (window.routes && window.routes[naam]) || fallback;
  }

  function isCadeau(item) {
    return (
      varianten.indexOf(String(item.variant_id)) !== -1 &&
      item.properties &&
      item.properties[cfg.eigenschap] === cfg.waarde
    );
  }

  // De actiecode moet in de winkelwagensessie staan. Shopify zet hem daar via
  // /discount/<code> (de QR op de flyer) of via het kortingsveld in de
  // checkout; `cart.discount_codes` bevat hem dan, hoofdletterongevoelig.
  function heeftCode(cart) {
    if (!cfg.code) return true;
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (String(codes[i].code).toLowerCase() === String(cfg.code).toLowerCase()) return true;
    }
    return false;
  }

  function haalCart() {
    return origFetch(pad('cart_url', '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return r.json();
    });
  }

  // Producttypes die niet meetellen voor de drempel (thuisbatterij, 04-11-2026).
  // Gelijk houden aan snippets/haribo-actie.liquid en de actievoorwaarde-collectie.
  var UITGESLOTEN = ['Energie & Opslag'];

  // Subtotaal van alles behalve de cadeauregel en de uitgesloten types, in centen.
  function subtotaalExclCadeau(cart) {
    return cart.items.reduce(function (som, item) {
      if (isCadeau(item) || UITGESLOTEN.indexOf(item.product_type) !== -1) return som;
      return som + item.final_line_price;
    }, 0);
  }

  // Fisher-Yates op een kopie — de lijst zelf blijft heel.
  function geschud(lijst) {
    var uit = lijst.slice();
    for (var i = uit.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = uit[i];
      uit[i] = uit[j];
      uit[j] = t;
    }
    return uit;
  }

  function probeerToe(kandidaten, index) {
    if (index >= kandidaten.length) return Promise.resolve(null);
    var props = {};
    props[cfg.eigenschap] = cfg.waarde;
    return origFetch(pad('cart_add_url', '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: kandidaten[index], quantity: 1, properties: props }],
      }),
    }).then(function (r) {
      // 422 = uitverkocht (inventory_policy: deny). Volgende zak proberen.
      if (r.ok) return r;
      return probeerToe(kandidaten, index + 1);
    });
  }

  function voegToe() {
    return probeerToe(geschud(varianten), 0);
  }

  function zetAantal(key, aantal) {
    return origFetch(pad('cart_change_url', '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: aantal }),
    });
  }

  // Vervangt de winkelwagen-onderdelen die op deze pagina staan. Zelfde
  // selectors als Dawn zelf gebruikt in cart.js/cart-drawer.js.
  function verversUI() {
    var url = pad('cart_url', '/cart');
    var taken = [];

    function haalSectie(sectie) {
      return origFetch(url + '?section_id=' + sectie)
        .then(function (r) {
          return r.text();
        })
        .then(function (tekst) {
          return new DOMParser().parseFromString(tekst, 'text/html');
        });
    }

    // Hele drawer-inhoud vervangen, net als Dawn zelf doet (#CartDrawer).
    // Alleen cart-drawer-items + de footer volstaat niet: de actiebalk staat
    // daarbuiten en bleef dan op de oude stand staan.
    if (document.querySelector('cart-drawer')) {
      taken.push(
        haalSectie('cart-drawer').then(function (html) {
          var doel = document.querySelector('#CartDrawer');
          var bron = html.querySelector('#CartDrawer');
          if (doel && bron) doel.innerHTML = bron.innerHTML;
        })
      );
    }
    if (document.querySelector('cart-items')) {
      taken.push(
        haalSectie('main-cart-items').then(function (html) {
          var doel = document.querySelector('cart-items');
          var bron = html.querySelector('cart-items');
          if (doel && bron) doel.innerHTML = bron.innerHTML;
        })
      );
    }
    if (document.getElementById('main-cart-footer')) {
      taken.push(
        haalSectie('main-cart-footer').then(function (html) {
          var doel = document.getElementById('main-cart-footer');
          var bron = html.getElementById('main-cart-footer');
          if (doel && bron) doel.innerHTML = bron.innerHTML;
        })
      );
    }
    if (document.getElementById('cart-icon-bubble')) {
      taken.push(
        haalSectie('cart-icon-bubble').then(function (html) {
          var doel = document.getElementById('cart-icon-bubble');
          var bron = html.getElementById('cart-icon-bubble');
          if (doel && bron) doel.innerHTML = bron.innerHTML;
        })
      );
    }
    return Promise.all(taken).catch(function (e) {
      console.error('[haribo-cadeau] verversen mislukt', e);
    });
  }

  // De balk in de winkelwagen. Het bedrag alléén bepaalt de tekst niet: boven
  // de drempel zónder code in de sessie komt er geen zak, en dan moet er geen
  // "is toegevoegd!" staan maar de knop die de code alsnog zet.
  function zetStand(cart) {
    var balken = document.querySelectorAll('[data-haribo-balk]');
    if (!balken.length) return;
    var stand = 'onder';
    if (cfg.actief && subtotaalExclCadeau(cart) >= cfg.drempel) {
      stand = heeftCode(cart) ? 'klaar' : 'code';
    }
    Array.prototype.forEach.call(balken, function (balk) {
      if (stand === 'klaar') balk.classList.add('haribo-actie--compleet');
      else balk.classList.remove('haribo-actie--compleet');
      Array.prototype.forEach.call(balk.querySelectorAll('[data-haribo-stand]'), function (el) {
        el.hidden = el.getAttribute('data-haribo-stand') !== stand;
      });
      var knop = balk.querySelector('[data-haribo-knop]');
      if (knop) knop.hidden = stand !== 'code';
    });
  }

  function sync() {
    if (bezig) return Promise.resolve();
    bezig = true;
    return haalCart()
      .then(function (cart) {
        var regel = cart.items.filter(isCadeau)[0];
        var subtotaal = subtotaalExclCadeau(cart);
        var mag = cfg.actief && subtotaal >= cfg.drempel && heeftCode(cart);
        // Na verversUI staat er verse HTML uit de Section Rendering API, dus
        // de stand moet er daarna opnieuw op. Het toevoegen of weghalen van
        // het cadeau verandert de stand zelf niet: die hangt aan het
        // subtotaal zónder cadeau en aan de code.
        var klaar = function (p) {
          return (p || Promise.resolve()).then(function () {
            zetStand(cart);
          });
        };

        if (mag && !regel) return klaar(voegToe().then(verversUI));
        if (!mag && regel) return klaar(zetAantal(regel.key, 0).then(verversUI));
        // Klant heeft het aantal van de cadeauregel opgehoogd: terug naar 1.
        if (regel && regel.quantity > 1) return klaar(zetAantal(regel.key, 1).then(verversUI));
        return klaar(null);
      })
      .catch(function (e) {
        // Uitverkocht of netwerkfout: stil laten lopen, de winkelwagen zelf
        // blijft gewoon werken.
        console.warn('[haribo-cadeau]', e);
      })
      .then(function () {
        bezig = false;
      });
  }

  // Meeliften op elke winkelwagen-mutatie van het thema.
  window.fetch = function () {
    var args = arguments;
    var resultaat = origFetch.apply(null, args);
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (!bezig && /\/cart\/(add|change|update|clear)/.test(url)) {
      resultaat.then(function () {
        setTimeout(sync, 50);
      });
    }
    return resultaat;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
